import { useEffect, useState } from "react"

const useParts = () => {
    const [parts, setParts] = useState([]);
    useEffect(() => {
        fetch('https://zara-car-manufacturer-house-server.vercel.app/parts')
            .then(res => res.json())
            .then(data => setParts(data))
    }, [parts])
    console.log(parts)
    return [parts, setParts];
}
export default useParts;